import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteGrupoMultiselectComponent } from './cliente-grupo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteGrupoMultiselectComponent
    ],
    exports: [
        ClienteGrupoMultiselectComponent
    ]
})
export class ClienteGrupoMultiselectModule { }
